import Modal from "../shared/Modal";
import "./ModalGoogleUnverified.css";

type ModalGoogleUnverifiedProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalGoogleUnverified = ({
  isOpen,
  onClose,
  onContinue,
}: ModalGoogleUnverifiedProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-google-verify">
          <div className="modal-collection-google-verify-title">
            Please Note
          </div>

          <div className="modal-collection-google-verify-content">
            We are currently completing a routine security audit required by
            Google for any company who wants to access the customers' Google
            drive folder content.
            <p />
            At this time our application is classified as "Unverified" so you
            will see this during the authentication process. You can complete
            the process regardless by clicking the "Advanced" link at the bottom
            left and then the "Go to Winslow (unsafe)" link that appears.
            <p />
            We expect our security audit to be complete in 30-60 days at which
            time this "Unverified" status will disappear. Please let us know if
            you have any questions.
          </div>

          <div className="modal-collection-google-verify-footer">
            <div className="modal-collection-google-verify-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Continue
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalGoogleUnverified;
